export const queryKeys = {
  COMPANY_TOKEN: 'COMPANY_TOKEN',
  ONE_C: 'ONE_C',
  EMBED_WIDGET: 'EMBED_WIDGET',
  MARKETPLACE_BOOKING_CONFIG: 'marketplace-booking-config'
};
